import React, { useState, useMemo, useEffect, useRef } from 'react';
//import { getOptionChainsSubject } from '../../../../../rxjs/behaviorSubjects/incomingmessage/OptionChainsSubject';
import { filter } from 'rxjs/operators';
import isEmpty from '../../../../../utils/objectchecking/IsEmpty';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import ApplyRounding from '../../../../../utils/math/ApplyRounding';
import Dialog from '@material-ui/core/Dialog';
import Draggable from 'react-draggable';
import {
  makeStyles,
  DialogContent,
  Typography,
  IconButton,
} from '@material-ui/core';
//import DisplayOptionChoices from "./DisplayOptionChoices";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import RadioGroup from '@material-ui/core/RadioGroup';
import { StyledRadio } from '../../../../../utils/designComponents/StyledRadio';
import StyledCheckbox from '../../../../../utils/componentutils/StyledCheckbox';
import CloseIcon from '@material-ui/icons/Close';
import { interval } from 'rxjs';
import { DataGrid } from '@material-ui/data-grid';
import CustomPagination from '../../../../../znotusedcurrently/orders/MaterialUIOrdersTable.jsx2';
import { requestOptionChains } from '../../../../../stores/websocketStore/utils/outgoingMessages/optionchains/requestOptionChains';
import { releaseOptionChains } from '../../../../../stores/websocketStore/utils/outgoingMessages/optionchains/releaseOptionChains';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';

const deselectOptionsBasedOnShortCuts = (
  selectAll,
  callType,
  putType,
  optionChoices,
  setOptionChoices,
  optionChains
) => {
  let chains = optionChains['chains'];
  if (chains === undefined) {
    return;
  }
  let deselectedAny = false;
  let frontCalls = callType === 'front';
  let frontPuts = putType === 'front';
  let allCalls = callType === 'all';
  let allPuts = putType === 'all';
  // let iterations = 0;
  const deselectOption = (option) => {
    let date = option['expiration_date'];
    let chain = undefined;
    if (optionChoices.choices === undefined) {
      optionChoices.choices = {};
    } else {
      chain = optionChoices.choices[date];
    }
    if (chain === undefined) {
      return;
    }
    chain = chain.filter((optionSymbol) => {
      return optionSymbol !== option.symbol;
    });
    if (chain.length === 0) {
      delete optionChoices.choices[date];
    } else {
      optionChoices.choices[date] = chain;
    }
    deselectedAny = true;
  };

  if (selectAll) {
    chains.forEach((element) => {
      for (let date in element) {
        let chain = element[date];
        chain.forEach((option) => {
          //  iterations++;
          /* let o = JSON.parse(option); */
          deselectOption(option);
        });
      }
    });
  } else {
    if (allCalls) {
      chains.forEach((element) => {
        for (let date in element) {
          let chain = element[date];
          chain.forEach((option) => {
            //   iterations++;
            /* let o = JSON.parse(option); */
            if (option['option_type'] === 'call') {
              deselectOption(option);
            }
          });
        }
      });
    } else {
      if (frontCalls) {
        let firstChain = chains[0];
        let chain = Object.values(firstChain)[0];
        chain.forEach((option) => {
          //    iterations++;
          let o = option; /* JSON.parse(option); */
          if (o['option_type'] === 'call') {
            deselectOption(o);
          }
        });
      }
    }
    if (allPuts) {
      chains.forEach((element) => {
        for (let date in element) {
          let chain = element[date];
          chain.forEach((option) => {
            //    iterations++;
            let o = option; /* let o = JSON.parse(option); */
            if (o['option_type'] === 'put') {
              deselectOption(o);
            }
          });
        }
      });
    } else {
      if (frontPuts) {
        let firstChain = chains[0];
        let chain = Object.values(firstChain)[0];
        chain.forEach((option) => {
          //   iterations++;
          let o = option; /* let o = JSON.parse(option); */
          if (o['option_type'] === 'put') {
            deselectOption(o);
          }
        });
      }
    }
  }
  if (deselectedAny) {
    setOptionChoices(optionChoices);
  }
};

export const selectOptionsBasedOnShortCuts = (
  selectAll,
  callType,
  putType,
  optionChoices,
  setOptionChoices,
  optionChains,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain
) => {
  let chains = optionChains['chains'];
  if (chains === undefined) {
    return;
  }
  let selectedAny = false;
  // let iterations = 0;
  let frontCalls = callType === 'front';
  let frontPuts = putType === 'front';
  let allCalls = callType === 'all';
  let allPuts = putType === 'all';
  let alreadySelectedOptionSymbols = {};
  if (optionChoices.choices !== undefined) {
    for (let date in optionChoices.choices) {
      let chain = optionChoices[date];
      for (let num in chain) {
        // iterations++;
        let optionSymbol = chain[num];
        alreadySelectedOptionSymbols[optionSymbol] = true;
        //if (option.symbol === optionSymbol) {
        //containSymbol = true;
        //break;
        //}
      }
    }
  }
  const selectOption = (option) => {
    //   console.log(option);
    let date = option['expiration_date'];
    let chain = undefined;
    if (optionChoices.choices === undefined) {
      optionChoices.choices = {};
    } else {
      chain = optionChoices.choices[date];
    }
    if (chain === undefined) {
      chain = [];
    }
    let containSymbol = false;
    //   for (let num in chain) {
    //   iterations++;
    //   let optionSymbol = chain[num];
    if (alreadySelectedOptionSymbols[option.symbol]) {
      containSymbol = true;
      // break;
    }
    // }
    if (!containSymbol) {
      chain.push(option.symbol);
      selectedAny = true;
      optionChoices.choices[date] = chain;
    }
    return;
  };

  if (selectAll) {
    chains.forEach((element) => {
      for (let date in element) {
        let chain = element[date];
        chain.forEach((option) => {
          //      iterations++;
          let o = option; /* let o = JSON.parse(option); */
          selectOption(o);
        });
      }
    });
  } else {
    if (allCalls) {
      chains.forEach((element) => {
        for (let date in element) {
          let chain = element[date];
          chain.forEach((option) => {
            //         iterations++;
            let o = option; /* let o = JSON.parse(option); */
            if (o['option_type'] === 'call') {
              selectOption(o);
            }
          });
        }
      });
    } else {
      if (frontCalls) {
        let firstChain = chains[0];
        let chain = Object.values(firstChain)[0];
        chain.forEach((option) => {
          //     iterations++;
          let o = option; /* let o = JSON.parse(option); */
          if (o['option_type'] === 'call') {
            selectOption(o);
          }
        });
      }
    }
    if (allPuts) {
      chains.forEach((element) => {
        for (let date in element) {
          let chain = element[date];
          chain.forEach((option) => {
            //       iterations++;
            let o = option; /* let o = JSON.parse(option); */
            if (o['option_type'] === 'put') {
              selectOption(o);
            }
          });
        }
      });
    } else {
      if (frontPuts) {
        let firstChain = chains[0];
        let chain = Object.values(firstChain)[0];
        chain.forEach((option) => {
          //     iterations++;
          /* let o = JSON.parse(option); */
          let o = option;
          if (o['option_type'] === 'put') {
            selectOption(o);
          }
        });
      }
    }
  }
  if (selectedAny) {
    setOptionChoices(optionChoices);
  }
  //key.notify
  if (!finishedRenderingOptionChain && setFinishedRenderingOptionChain) {
    setFinishedRenderingOptionChain(true);
  }
};

export const useOptionShortCutEffect = (
  optionChains,
  optionChoices,
  setOptionChoices,
  selectAll,
  callType,
  putType,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain, // setLetEnterNowKnowOptionsDone
  symbol,
  ds,
  goLong,
  goShort,
  expirationDates,
  optionShortCutRefs
) => {
  let [
    prevSymbolRef,
    prevDsRef,
    prevExpirationDatesRef,
    prevGoLongRef,
    prevGoShortRef,
    prevSelectAllRef,
    prevCallTypeRef,
    prevPutTypeRef,
    optionChainKeys,
  ] = optionShortCutRefs;
  /*const prevSymbolRef = useRef("");
      const prevDsRef = useRef("");
      const prevExpirationDatesRef = useRef("");
      const prevGoLongRef = useRef(false);
      const prevGoShortRef = useRef(false);
      const prevSelectAllRef = useRef(false);
      const prevCallTypeRef = useRef("");
      const prevPutTypeRef = useRef("");
      const optionChainKeys = useRef("");*/
  //console.log(optionChains.chains);
  //console.log(JSON.stringify(expirationDates));
  let chainKeys = '';
  if (!isEmpty(optionChains) && !isEmpty(optionChains['chains'])) {
    let c = optionChains['chains'];
    for (let i in c) {
      let chain = c[i];
      // console.log(Object.keys(chain)[0]);
      chainKeys += JSON.stringify(Object.keys(chain)[0]);
    }
  }
  //console.log(chainKeys);
  useEffect(() => {
    // console.log(optionShortCutRefs);

    //when option chain resets or anything in optionShortCuts, choose options based on these buttons
    if (
      prevGoLongRef.current === goLong &&
      prevGoShortRef.current === goShort &&
      prevSymbolRef.current === symbol &&
      prevDsRef.current === ds &&
      prevExpirationDatesRef.current === JSON.stringify(expirationDates) &&
      prevSelectAllRef.current === selectAll &&
      prevCallTypeRef.current === callType &&
      prevPutTypeRef.current === putType &&
      optionChainKeys.current === chainKeys
    ) {
      //console.log("returning and not using use effect")
      if (!finishedRenderingOptionChain && setFinishedRenderingOptionChain) {
        //console.log("set")
        setFinishedRenderingOptionChain(true);
      }
      return;
    } else {
      prevGoLongRef.current = goLong;
      prevGoShortRef.current = goShort;
      prevSymbolRef.current = symbol;
      prevDsRef.current = ds;
      prevExpirationDatesRef.current = JSON.stringify(expirationDates);
      prevSelectAllRef.current = selectAll;
      prevCallTypeRef.current = callType;
      prevPutTypeRef.current = putType;
      optionChainKeys.current = chainKeys;
    }
    if (optionChains !== undefined) {
      optionChoices = {};
      selectOptionsBasedOnShortCuts(
        selectAll,
        callType,
        putType,
        optionChoices,
        setOptionChoices,
        optionChains,
        finishedRenderingOptionChain,
        setFinishedRenderingOptionChain
      );
      //            if (setLetEnterNowKnowOptionsDone) {
      //  setLetEnterNowKnowOptionsDone(true);
      //}
    }
  }, [optionChains, selectAll, callType, putType]);
};
export const OptionShortCutsCheckBoxes = ({
  optionShortCutRefs,
  optionShortCutsPackage,
  highBarrier,
  lowBarrier,
  optionChoices,
  optionChains,
  setOptionChoices,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
  showAllOptionsSelect,
  symbol,
  ds,
  goLong,
  goShort,
  expirationDates,
  //labelPlacement
}) => {
  let [selectAll, setSelectAll, callType, setCallType, putType, setPutType] =
    optionShortCutsPackage;

  useOptionShortCutEffect(
    optionChains,
    optionChoices,
    setOptionChoices,
    selectAll,
    callType,
    putType,
    finishedRenderingOptionChain,
    setFinishedRenderingOptionChain,
    symbol,
    ds,
    goLong,
    goShort,
    expirationDates,
    optionShortCutRefs
  );

  /* console.log(optionChains);
  console.log(optionChoices); */

  const handleChangePuts = (ev) => {
    let value = ev.target.value;
    switch (value) {
      case 'all':
        setPutType('all');
        selectOptionsBasedOnShortCuts(
          selectAll,
          callType,
          'all',
          optionChoices,
          setOptionChoices,
          optionChains
        );
        break;
      case 'none':
        deselectOptionsBasedOnShortCuts(
          selectAll,
          callType,
          'all',
          optionChoices,
          setOptionChoices,
          optionChains
        );
        setPutType('none');
        selectOptionsBasedOnShortCuts(
          selectAll,
          callType,
          'none',
          optionChoices,
          setOptionChoices,
          optionChains
        );
        break;
      case 'front':
        deselectOptionsBasedOnShortCuts(
          selectAll,
          callType,
          putType,
          optionChoices,
          setOptionChoices,
          optionChains
        );
        setPutType('front');
        selectOptionsBasedOnShortCuts(
          selectAll,
          callType,
          'front',
          optionChoices,
          setOptionChoices,
          optionChains
        );
        break;
    }
  };
  const handleChangeCalls = (ev) => {
    let value = ev.target.value;
    switch (value) {
      case 'all':
        setCallType('all');
        selectOptionsBasedOnShortCuts(
          selectAll,
          'all',
          putType,
          optionChoices,
          setOptionChoices,
          optionChains
        );
        break;
      case 'none':
        deselectOptionsBasedOnShortCuts(
          selectAll,
          'all',
          putType,
          optionChoices,
          setOptionChoices,
          optionChains
        );
        setCallType('none');
        selectOptionsBasedOnShortCuts(
          selectAll,
          'none',
          putType,
          optionChoices,
          setOptionChoices,
          optionChains
        );
        break;
      case 'front':
        deselectOptionsBasedOnShortCuts(
          selectAll,
          callType,
          putType,
          optionChoices,
          setOptionChoices,
          optionChains
        );
        setCallType('front');
        selectOptionsBasedOnShortCuts(
          selectAll,
          'front',
          putType,
          optionChoices,
          setOptionChoices,
          optionChains
        );
        break;
    }
  };
  return (
    <Grid item container>
      {/* <Grid item xs={12}>
        <Typography style={{ fontSize: 10 }}>
          Choose options between prices: {lowBarrier} and {highBarrier} for
          selected expirations
        </Typography>
      </Grid> */}
      <Grid item container xs={12}>
        {showAllOptionsSelect ? (
          <Grid item xs={2}>
            <FormControlLabel
              checked={selectAll}
              control={
                <StyledCheckbox
                  color="primary" //checked={isAlreadyWorkOrder}
                  onChange={(ev) => {
                    setSelectAll(ev.target.checked);
                    if (ev.target.checked) {
                      selectOptionsBasedOnShortCuts(
                        true,
                        callType,
                        putType,
                        optionChoices,
                        setOptionChoices,
                        optionChains
                      );
                      setCallType('all');
                      setPutType('all');
                    } else {
                      deselectOptionsBasedOnShortCuts(
                        true,
                        callType,
                        putType,
                        optionChoices,
                        setOptionChoices,
                        optionChains
                      );
                      setCallType('none');
                      setPutType('none');
                    }
                  }}
                />
              }
              label={
                <Typography style={{ fontSize: 12, color: 'blue' }}>
                  All options
                </Typography>
              }
              labelPlacement={'top'}
              //labelPlacement="start"
            />
          </Grid>
        ) : null}
        <Grid item xs={1} />
        <Grid item xs={4}>
          <Grid item xs={2}>
            <FormLabel>
              <Typography style={{ fontSize: 12, color: 'blue' }}>
                Calls
              </Typography>
            </FormLabel>
          </Grid>
          <FormControl component="fieldset">
            <RadioGroup onChange={handleChangeCalls} row value={callType}>
              <Grid item xs={4}>
                <FormControlLabel
                  value="none"
                  control={<StyledRadio />}
                  label={<Typography style={{ fontSize: 10 }}>none</Typography>}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  value="all"
                  control={<StyledRadio />}
                  label={<Typography style={{ fontSize: 10 }}>all</Typography>}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  value="front"
                  control={<StyledRadio />}
                  label={
                    <Typography style={{ fontSize: 10 }}>front</Typography>
                  }
                />
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={4}>
          <Grid item xs={2}>
            <FormLabel>
              <Typography style={{ fontSize: 12, color: 'blue' }}>
                Puts
              </Typography>
            </FormLabel>
          </Grid>
          <FormControl component="fieldset">
            <RadioGroup onChange={handleChangePuts} row value={putType}>
              <Grid item xs={4}>
                <FormControlLabel
                  value="none"
                  control={<StyledRadio />}
                  label={<Typography style={{ fontSize: 10 }}>none</Typography>}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  value="all"
                  control={<StyledRadio />}
                  label={<Typography style={{ fontSize: 10 }}>all</Typography>}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  value="front"
                  control={<StyledRadio />}
                  label={
                    <Typography style={{ fontSize: 10 }}>front</Typography>
                  }
                />
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};
const OptionPriceRangeComponent = ({ option_price_range }) => {
  if (option_price_range === undefined) {
    return <></>;
  }
  let [optionPriceRangeEnabled, optionPriceRange, dispatchOptionPriceRange] =
    option_price_range;

  if (optionPriceRangeEnabled) {
    return (
      <>
        <Grid item container>
          <Grid item xs={6}>
            <Typography style={{ fontSize: 8 }}> min price:</Typography>
            <Grid item>
              <TextField
                id="standard-size-small"
                value={optionPriceRange.minPrice}
                onChange={(ev) =>
                  dispatchOptionPriceRange({ minPrice: ev.target.value })
                }
                size="small"
              />
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Typography style={{ fontSize: 8 }}> max price:</Typography>
            <Grid item>
              <TextField
                id="standard-size-small"
                value={optionPriceRange.maxPrice}
                onChange={(ev) =>
                  dispatchOptionPriceRange({ maxPrice: ev.target.value })
                }
                size="small"
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  } else {
    return <></>;
  }
};

const TightSpreadPctComponent = ({ tight_spreadPct }) => {
  if (tight_spreadPct === undefined) {
    return <></>;
  }
  let [tightSpreadPctEnabled, tightSpreadPct, dispatchTightSpreadPct] =
    tight_spreadPct;

  if (tightSpreadPctEnabled) {
    return (
      <>
        <Grid item container>
          <Grid item>
            <Typography style={{ fontSize: 8 }}> tight spread pct:</Typography>
            <Grid item>
              <TextField
                id="standard-size-small"
                value={tightSpreadPct.maxOptionSpreadPct}
                onChange={(ev) =>
                  dispatchTightSpreadPct({
                    maxOptionSpreadPct: ev.target.value,
                  })
                }
                size="small"
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  } else {
    return <></>;
  }
};

const useStyles = makeStyles((theme) => ({
  paper: { minWidth: '1300px' },
}));
export default function RenderOptionChains(props) {
  let classes = useStyles();
  const [open, setOpen] = useState(false);
  const [optionChoices, setOptionChoices] = props.optionChoices;
  const [optionChains, setOptionChains] = props.optionChains;
  let top = props.top;
  let DisplayOptionChoices = props.displayOptionComponent;
  return (
    <div>
      {/*<CreateSubscription
symbol={top.symbol}
dataSource={top.dataSource}
expirationDates={props.expirationDates}
optionChains={props.optionChains}
/>*/}
      <Grid item xs={12}>
        <Button
          style={{ width: '100%', height: 30 }}
          variant="contained"
          color="primary"
          size={'small'}
          onClick={(evt) => {
            setOpen(open !== true);
            evt.preventDefault();
          }}
        >
          <Typography style={{ fontSize: 10 }}>Select Options</Typography>
        </Button>
      </Grid>
      <Draggable>
        <Dialog
          classes={{ paper: classes.paper }}
          open={open}
          onClose={() => {
            let symbolCount = 0;
            setOpen(false);
            for (let date in optionChoices.choices) {
              let chain = optionChoices.choices[date];
              symbolCount += Object.keys(chain).length;
            }
            props.setSymbolsUsed(1 + symbolCount);
            setOptionChoices(optionChoices);
          }}
        >
          <DialogContent style={{ minWidth: '1300px' }}>
            <Grid item xs={12}>
              <IconButton
                onClick={() => {
                  let symbolCount = 0;
                  setOpen(false);
                  for (let date in optionChoices.choices) {
                    let chain = optionChoices.choices[date];
                    symbolCount += Object.keys(chain).length;
                  }
                  props.setSymbolsUsed(1 + symbolCount);
                  setOptionChoices(optionChoices);
                }}
                style={{ color: 'red' }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <>
              <Grid item container>
                <Grid item xs={1}>
                  <TightSpreadPctComponent
                    tight_spread={props.tightSpreadPct}
                  />
                </Grid>
                <Grid item xs={1}>
                  <OptionPriceRangeComponent
                    option_price_range={props.optionPriceRange}
                  />
                </Grid>
                {!props.selectSingle ? (
                  <Grid item xs={7}>
                    {/*   <OptionShortCutsPackage optionShortCutsPackage={optionShortCutPackage}/>*/}
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
              <ParseOptionsDataIntoTable
                optionChains={optionChains}
                date={props.expirationDates}
                symbol={top.symbol}
                optionChoices={[optionChoices, setOptionChoices]}
                selectSingle={props.selectSingle}
                /*    optionShortCutPackage={optionShortCutPackage}*/
              />
            </>
          </DialogContent>
        </Dialog>
      </Draggable>
      {props.showSelectedOptions ? (
        <DisplayOptionChoices
          optionChoices={optionChoices}
          optionChains={optionChains}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
var runningNumber = 0;

export function CreateSubscriptionForOptionChains(props) {
  const { optionChainsSubject } = useWebsocketStore();
  return (
    <CreateSubscription {...props} optionChainsSubject={optionChainsSubject} />
  );
}

//export default
export class CreateSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.expirationDates = props.expirationDates;
    this.symbol = props.symbol;
    this.dataSource = props.dataSource;
    this.brokerage = props.brokerage;
    this.id = runningNumber++;
  }

  componentDidMount() {
    const [optionChains, setOptionChains] = this.props.optionChains;
    this.subscription = this.props.optionChainsSubject
      .pipe(filter((msg) => parseInt(msg.id) === this.id))
      .subscribe((msg) => {
        setOptionChains(msg);
      });
    if (this.props.finishedRenderingOptionChain) {
      //console.log("from option chains setting to false");
      this.props.setFinishedRenderingOptionChain(false);
    }
    requestOptionChains(
      this.id,
      this.expirationDates,
      this.symbol,
      this.dataSource,
      this.brokerage,
      this.props.accountNumber
    );

    this.intervalSubscription = interval(15000).subscribe(() => {
      requestOptionChains(
        this.id,
        this.props.expirationDates,
        this.props.symbol,
        this.props.dataSource,
        this.props.brokerage,
        this.props.accountNumber
      );
    });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
    this.intervalSubscription.unsubscribe();

    releaseOptionChains(this.id, this.dataSource);
  }

  render() {
    let sameSymbols = this.symbol === this.props.symbol;
    let sameDs = this.dataSource === this.props.dataSource;
    let sameBrokerage = this.brokerage === this.props.brokerage;
    let sameExpiration = true;
    if (this.props.expirationDates.length !== this.expirationDates.length) {
      sameExpiration = false;
    } else {
      for (let num in this.props.expirationDates) {
        let date = this.props.expirationDates[num];
        let containsDate = false;
        for (let n in this.expirationDates) {
          let d = this.expirationDates[n];
          if (date === d) {
            containsDate = true;
            continue;
          }
        }
        if (!containsDate) {
          sameExpiration = false;
          break;
        }
      }
    }
    this.symbol = this.props.symbol;
    this.dataSource = this.props.dataSource;
    this.brokerage = this.props.brokerage;
    this.expirationDates = [];
    for (let i in this.props.expirationDates) {
      this.expirationDates.push(this.props.expirationDates[i]);
    }
    if (!sameSymbols || !sameDs || !sameBrokerage || !sameExpiration) {
      requestOptionChains(
        this.id,
        this.props.expirationDates,
        this.props.symbol,
        this.props.dataSource,
        this.props.brokerage,
        this.props.accountNumber,
      );
    }
    return <></>;
  }
}

const css = {
  floatLeft: { width: '50%', float: 'left' },
  floatRight: { width: '50%', float: 'right' },
};

function ParseOptionsDataIntoTable({
  optionChains,
  symbol,
  optionChoices,
  selectSingle /*optionShortCutPackage*/,
}) {
  if (optionChains === undefined || isEmpty(optionChains)) {
    return <div>no option chain available!</div>;
  }
  let parsedChains = {};
  //const [oc, setOptionChoices] = optionChoices;
  //oc.choices = {};
  //console.log(optionChains);
  let chains = optionChains['chains'];
  chains.forEach((element) => {
    for (let date in element) {
      let chain = element[date];
      let calls = [];
      let puts = [];
      chain.forEach((o) => {
        let option = o; /* JSON.parse(o); */
        option.bid = ApplyRounding(option.bid, 2);
        option.ask = ApplyRounding(option.ask, 2);
        if (option['option_type'] === 'call') {
          calls.push(option);
          return;
        }
        if (option['option_type'] === 'put') {
          puts.push(option);
          return;
        }
      });
      parsedChains[date] = [];
      parsedChains[date].push(calls);
      parsedChains[date].push(puts);
    }
  });
  let tables = [];
  for (let date in parsedChains) {
    parsedChains[date].forEach((chain) => {
      //    iterations++;;
      /* console.log(parsedChains);
      console.log(date);
      console.log(parsedChains[date]);
      console.log(chain); */
      let callOrPut = chain[0]['option_type'] === 'call' ? 'call' : 'put';
      let style = callOrPut === 'call' ? css.floatLeft : css.floatRight;
      tables.push(
        <div key={date + callOrPut} style={style}>
          {/* {selectSingle ? (
                        <SingleSelectOptionChainTable
                            key={date + callOrPut}
                            optionChain={chain}
                            date={date}
                            symbol={symbol}
                            optionChoices={optionChoices}
                        />
                    ) : (*/}
          <MultiSelectOptionChainTable
            key={date + callOrPut}
            optionChain={chain}
            date={date}
            symbol={symbol}
            optionChoiceProp={optionChoices}
            isCall={callOrPut === 'call'}
            /* optionShortCutPackage={optionShortCutPackage}*/
          />
          {/*)}*/}
          <br />
          <br />
        </div>
      );
    });
  }
  return <div>{tables}</div>;
}

function getDelta(props) {
  if (!props.value) {
    return 0;
  }
  return /*<div>{*/ ApplyRounding(props.value.delta, 2); /*}</div>;*/
}

function FirstLetterOptionType(props) {
  return /*<div>{*/ props.value.charAt(0).toUpperCase(); /*}</div>;*/
}

class SingleSelectOptionChainTable extends React.Component {
  constructor(props) {
    super(props);
    //this.rowSelection = this.props.selectSingle === true ? "single" : " multiple";
    this.state = {
      lastSymbolChosen: '',
      columnNames: [
        {
          headerName: props.date + '|' + props.symbol,
          children: [
            {
              headerName: 'call|put',
              field: 'option_type',
              resizable: true,
              cellRenderer: 'firstLetterOptionType',
              width: 35,
            },
            {
              headerName: 'strike',
              field: 'strike',
              resizable: true,
            },
            {
              headerName: 'bid',
              field: 'bid',
              resizable: true,
            },
            {
              headerName: 'ask',
              field: 'ask',
              resizable: true,
            },
            {
              headerName: 'delta',
              field: 'greeks.delta',
              resizable: true,
              cellRenderer: 'roundDelta',
            },
            {
              headerName: 'vol',
              field: 'volume',
              resizable: true,
              width: 60,
            },
            {
              headerName: 'OI',
              field: 'open_interest',
              resizable: true,
              width: 55,
            },
            {
              resizable: true,
              // headerCheckboxSelection: true,
              checkboxSelection: true,
            },
          ],
        },
      ],
      frameworkComponents: {
        roundDelta: getDelta,
        firstLetterOptionType: FirstLetterOptionType,
      },
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.optionChoices = this.props.optionChoices;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi = params.columnApi;
    //if not done like this but rather through the component, seems to lose previous set data
    this.gridApi.setColumnDefs(this.state.columnNames);
    this.gridApi.setRowData(this.props.optionChain);

    var allColIds = params.columnApi.getAllColumns().map((column) => {
      if (
        column.colId !== 'open_interest' &&
        column.colId !== 'volume' &&
        column.colId !== 'option_type'
      ) {
        return column.colId;
      }
    });
    params.columnApi.autoSizeColumns(allColIds);
    let [optionChoices, setOptionChoices] = this.gridApi.optionChoices;
    //let formattedDate = formatDate(this.props.date);
    let date = this.props.date;
    if (optionChoices.choices !== undefined) {
      if (optionChoices.choices[date] != undefined) {
        let chain = optionChoices.choices[date];
        this.gridApi.forEachNode((node) => {
          for (let num in chain) {
            let optionSymbol = chain[num];
            if (optionSymbol === node.data.symbol) {
              node.setSelected(true);
              return;
            }
          }
        });
      }
    }
  }

  render() {
    return (
      <div
        className="ag-theme-balham"
        style={{ height: '500px', width: '550px', fontSize: 9 }}
      >
        <AgGridReact
          ref="agGrid"
          //columnDefs={this.state.columnNames}
          //rowData={this.props.optionChain}
          onGridReady={this.onGridReady.bind(this)}
          rowSelection="single"
          groupSelectsChildren={false}
          suppressRowClickSelection={true}
          onRowSelected={selectOptionChoice}
          //  onFirstDataRendered={this.loadPreviousOptionChoices.bind(this)}
          frameworkComponents={this.state.frameworkComponents}
        />
      </div>
    );
  }
}

const gridStyles = makeStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    fontSize: 11,
  },
}));

function MultiSelectOptionChainTable({
  date,
  symbol,
  optionChain,
  optionChoiceProp,
  isCall,
}) {
  //todo!! signgle select option table! make everything else async as well
  let optionChoices = optionChoiceProp[0];
  let setupOptionChoices = optionChoiceProp[1];
  const classes = gridStyles();
  let headerName = date + '|' + symbol;
  const columns = [
    {
      headerName: 'call|put',
      field: 'option_type',
      sortable: false,
      valueFormatter: FirstLetterOptionType,
      width: 90,
    },
    {
      headerName: 'strike',
      field: 'strike',
      sortable: false,
      width: 85,
    },
    {
      headerName: 'bid',
      field: 'bid',
      sortable: false,
    },
    {
      headerName: 'ask',
      field: 'ask',
      sortable: false,
    },
    {
      headerName: 'delta',
      field: 'greeks',
      sortable: false,
      valueFormatter: getDelta,
      width: 80,
    },
    {
      headerName: 'vol',
      sortable: false,
      field: 'volume',
      width: 70,
    },
    {
      headerName: 'OI',
      sortable: false,
      field: 'open_interest',
      width: 70,
    },
  ];

  const [selectionModel, setSelectionModel] = React.useState({});

  const evaluateChoices = (callPutFunction) => {
    let newSelectionModel = selectionModel;
    let rerender = false;
    let foundDate = false;
    Object.keys(optionChoices.choices).forEach((expirationDate) => {
      if (date === expirationDate) {
        foundDate = true;
        newSelectionModel = {};
        let chain = optionChoices.choices[date];
        if (isEmpty(chain) && !isEmpty(selectionModel)) {
          rerender = true; //wont hit the rerender below bc chain is empty, but we should tell selection model to empty
        }
        for (let i in chain) {
          let symbol = chain[i];
          if (callPutFunction(symbol.substring(6))) {
            if (!newSelectionModel[symbol]) {
              newSelectionModel[symbol] = true;
              rerender = true;
            }
          }
        }
      }
    });
    if (!foundDate && !isEmpty(selectionModel)) {
      //wont hit the rerender=true above bc did not find date, but we should tell selection model to empty
      newSelectionModel = {};
      rerender = true;
    }
    return [newSelectionModel, rerender];
  };

  useEffect(() => {
    let callPutFunction;
    if (isCall) {
      callPutFunction = (subString) => subString.includes('C');
    } else {
      callPutFunction = (subString) => subString.includes('P');
    }
    if (!isEmpty(optionChoices)) {
      let [newSelectionModel, rerender] = evaluateChoices(callPutFunction); //;.then(arr => {

      if (rerender) {
        setSelectionModel(newSelectionModel);
      }
      //});
    }
  }, [optionChoiceProp]); //[(optionChoiceProp[0] ? optionChoiceProp[0].choices ? optionChoices[0].choices[date] ? optionChoices[0].choices[date] : undefined : undefined : undefined)]);

  const recreateOptionChoicesWithoutThisChain = (optionChoices) => {
    let newOptionChoices = {};
    newOptionChoices.choices = {};
    if (newOptionChoices.choices[date] === undefined) {
      newOptionChoices.choices[date] = [];
    }
    let callPutFunction;
    if (isCall) {
      callPutFunction = (subString) => subString.includes('C');
    } else {
      callPutFunction = (subString) => subString.includes('P');
    }
    if (optionChoices.choices !== undefined) {
      Object.keys(optionChoices.choices).forEach((key) => {
        if (key !== date) {
          newOptionChoices.choices[key] = optionChoices.choices[key];
        } else {
          let chain = optionChoices.choices[key];
          chain.forEach((symbol) => {
            if (!callPutFunction(symbol.substring(6))) {
              newOptionChoices.choices[key].push(symbol);
            }
          });
        }
      });
    }
    return newOptionChoices;
  };
  const onSelectionChange = (newSelection) => {
    //console.log(newSelection);
    let newOptionChoices = recreateOptionChoicesWithoutThisChain(optionChoices); //.then(newOptionChoices => {
    //console.log(newOptionChoices);
    //console.log(date);

    let chain = newOptionChoices.choices[date];
    //console.log(chain);
    let [newSelectionModel, oc] = findNewChoicesAndSelectionModal(
      chain,
      newSelection,
      newOptionChoices
    ); //.then(arr => {
    //  let [newSelectionModel, optionChoices] = arr;
    //console.log(newSelectionModel);
    setSelectionModel(newSelectionModel);
    setupOptionChoices(oc);
    //}
    //)
    //}
    //)
  };
  const findNewChoicesAndSelectionModal = (chain, rowIds, optionChoices) => {
    let newSelectionModel = {};
    let optionChoiceChainAsMap = {};
    //console.log(chain);
    const iterateChain = () =>
      chain?.forEach((symbol) => (optionChoiceChainAsMap[symbol] = true));
    const iterateRowIds = () => {
      rowIds?.forEach((symbol) => {
        if (!optionChoiceChainAsMap[symbol]) {
          chain.push(symbol);
        }
        newSelectionModel[symbol] = true;
      });
    };
    iterateChain();
    iterateRowIds();

    if (isEmpty(chain)) {
      delete optionChoices.choices[date];
    } else {
      optionChoices.choices[date] = chain;
    }
    return [newSelectionModel, optionChoices];
  };
  //console.log(optionChain);
  if (optionChain.length === 0) {
    return;
  }
  return (
    <div style={{ height: 410, width: '100%' }}>
      {headerName}
      <DataGrid
        getRowId={(row) => row.symbol}
        checkboxSelection
        onSelectionModelChange={(newSelection) => {
          onSelectionChange(newSelection);
        }}
        selectionModel={Object.keys(selectionModel)}
        className={classes.root}
        rows={optionChain}
        columns={columns}
        rowHeight={20}
        headerHeight={25}
        pageSize={100}
        scrollbarSize={1}
        components={{ pagination: CustomPagination }}
      />
    </div>
  );
}

/*
const [optionChoices, setOptionChoices] = params.api.optionChoices;
    let option = params.data;
    let date = option.expiration_date;
    let chain = undefined;
    if (optionChoices.choices === undefined) {
        optionChoices.choices = {};
    } else {
        chain = optionChoices.choices[date];
    }
    if (params.node.isSelected()) {
        if (chain === undefined) {
            chain = [];
        }
        let containSymbol = false;
        for (let num in chain) {
            let optionSymbol = chain[num];
            if (option.symbol === optionSymbol) {
                containSymbol = true;
                break;
            }
        }
        if (!containSymbol) {
            chain.push(option.symbol);
            optionChoices.choices[date] = chain;
        }
        return;
    }

    if (!params.node.isSelected()) {
        if (chain === undefined) {
            return;
        }
        chain = chain.filter((optionSymbol) => {
            return optionSymbol !== option.symbol;
        });
        if (chain.length === 0) {
            delete optionChoices.choices[date];
        } else {
            optionChoices.choices[date] = chain;
        }
        //setOptionChoices(optionChoices);
    }
 */

/*

class MultiSelectOptionChainTable extends React.Component {
    constructor(props) {
        super(props);
        //this.rowSelection = this.props.selectSingle === true ? "single" : " multiple";
        this.state = {
            lastSymbolChosen: "",
            columnNames: [
                {
                    headerName: props.date + "|" + props.symbol,
                    children: [
                        {
                            headerName: "call|put",
                            field: "option_type",
                            resizable: true,
                            cellRenderer: "firstLetterOptionType",
                        },
                        {
                            headerName: "strike",
                            field: "strike",
                            resizable: true,
                        },
                        {
                            headerName: "bid",
                            field: "bid",
                            resizable: true,
                        },
                        {
                            headerName: "ask",
                            field: "ask",
                            resizable: true,
                        },
                        {
                            headerName: "delta",
                            field: "greeks.delta",
                            resizable: true,
                            cellRenderer: "roundDelta",
                        },
                        {
                            headerName: "vol",
                            field: "volume",
                            resizable: true,
                            width: 65,
                        },
                        {
                            headerName: "OI",
                            field: "open_interest",
                            resizable: true,
                            width: 65,
                        },
                        {
                            resizable: true,
                            headerCheckboxSelection: true,
                            checkboxSelection: true,
                        },
                    ],
                },
            ],
            frameworkComponents: {
                roundDelta: RoundDelta,
                firstLetterOptionType: FirstLetterOptionType,
            },
        };
    }

    onGridReady(params) {
        //let [selectAll, setSelectAll, allCalls, setAllCalls, allPuts, setAllPuts] = this.props.optionShortCutPackage;
        this.gridApi = params.api;
        this.gridApi.optionChoices = this.props.optionChoices;
        this.gridColumnApi = params.columnApi;
        this.gridColumnApi = params.columnApi;
        //if not done like this but rather through the component, seems to lose previous set data
        this.gridApi.setColumnDefs(this.state.columnNames);
        this.gridApi.setRowData(this.props.optionChain);

        var allColIds = params.columnApi.getAllColumns().map((column) => {
            if (column.colId !== "open_interest" && column.colId !== "volume") {
                return column.colId;
            }
        });
        let [optionChoices, setOptionChoices] = this.gridApi.optionChoices;
        //let iterations = 0;
        //let formattedDate = formatDate(this.props.date);
        let date = this.props.date;
        if (optionChoices.choices !== undefined) {
            if (optionChoices.choices[date] !== undefined) {
                let chain = optionChoices.choices[date];
                this.gridApi.forEachNode((node) => {
                    for (let num in chain) {
                        //    iterations++;
                        let optionSymbol = chain[num];
                        if (optionSymbol === node.data.symbol) {
                            node.setSelected(true);
                            return;
                        }
                    }
                });
            }
        }
        params.columnApi.autoSizeColumns(allColIds);
    }

    render() {
        return (
            <div
                className="ag-theme-balham"
                style={{height: "500px", width: "550px", fontSize: 9}}
            >
                <AgGridReact
                    ref="agGrid"
                    onGridReady={this.onGridReady.bind(this)}
                    rowSelection="multiple"
                    groupSelectsChildren={true}
                    suppressRowClickSelection={true}
                    rowData={this.props.optionChain}
                    onRowSelected={selectOptionChoice}
                    frameworkComponents={this.state.frameworkComponents}
                />
            </div>
        );
    }
}
*/
function selectOptionChoice(params) {
  const [optionChoices, setOptionChoices] = params.api.optionChoices;
  let option = params.data;
  let date = option.expiration_date;
  let chain = undefined;
  if (optionChoices.choices === undefined) {
    optionChoices.choices = {};
  } else {
    chain = optionChoices.choices[date];
  }
  if (params.node.isSelected()) {
    if (chain === undefined) {
      chain = [];
    }
    let containSymbol = false;
    for (let num in chain) {
      let optionSymbol = chain[num];
      if (option.symbol === optionSymbol) {
        containSymbol = true;
        break;
      }
    }
    if (!containSymbol) {
      chain.push(option.symbol);
      optionChoices.choices[date] = chain;
    }
    return;
  }

  if (!params.node.isSelected()) {
    if (chain === undefined) {
      return;
    }
    chain = chain.filter((optionSymbol) => {
      return optionSymbol !== option.symbol;
    });
    if (chain.length === 0) {
      delete optionChoices.choices[date];
    } else {
      optionChoices.choices[date] = chain;
    }
    //setOptionChoices(optionChoices);
  }
}
